import React from 'react';
import { 
  Box, 
  Typography, 
  Button, 
  TextField, 
  Paper,
  useTheme
} from '@mui/material';
import { stepTwoStyles } from '../../styles/locationCampaign/stepTwo';
import background from '../../assets/images/location_campaign/lemn.png';
import kozel from '../../assets/images/location_campaign/logo.png';
import premiu from '../../assets/images/location_campaign/premiu.png';
import despre_alcool from '../../assets/images/promo-despre-alcool.png';
import linie1 from '../../assets/images/location_campaign/linie1.png';
import linie2 from '../../assets/images/location_campaign/linie2.png';

interface StepTwoProps {
  nume: string;
  prenume: string;
  telefon: string;
  onInputChange: (field: string, value: string) => void;
  onNext: () => void;
  errors: { [key: string]: string };
}

export default function StepTwo({ nume, prenume, telefon, onInputChange, onNext, errors }: StepTwoProps) {
  const theme = useTheme();

  const handleNext = () => {
    const isNumeValid = nume.trim().length > 0;
    const isPrenumeValid = prenume.trim().length > 0;
    const isTelefonValid = telefon.trim().length > 0 && /^07\d{8}$/.test(telefon);
    
    if (!isNumeValid || !isPrenumeValid || !isTelefonValid || 
        errors.nume || errors.prenume || errors.telefon) {
      return;
    }
    onNext();
  };

  return (
    <Box sx={stepTwoStyles.container}>
      <Paper elevation={0} sx={stepTwoStyles.paper(background)}>
          {/* Header */}
          <Box sx={stepTwoStyles.header}>
            <Box
              component="img"
              src={kozel}
              alt="Kozel"
              sx={stepTwoStyles.logo}
            />
          </Box>

          <Box sx={stepTwoStyles.content}>
            {/* Main Title */}
             <Typography variant="h1" sx={stepTwoStyles.mainTitle(theme)}>
              MEEEEEEREU ÎMPREUNĂ
            </Typography>
            
            <Typography variant="h4" sx={stepTwoStyles.subtitle(theme)}>
              CÂȘTIGĂM PREMII
            </Typography>

            {/* Prize Section */}
            <Box sx={stepTwoStyles.prizeSection}>
              <Typography variant="h6" sx={stepTwoStyles.prizeTitle}>
                TOMBOLĂ LA FINAL DE CAMPANIE
              </Typography>
              
              <Box sx={stepTwoStyles.prizeContent}>
                <Box sx={stepTwoStyles.prizeLeftSection}>
                  <Box sx={stepTwoStyles.prizeCircle}>
                    <Typography sx={stepTwoStyles.prizeCircleNumber}>
                      60
                    </Typography>
                    <Typography sx={stepTwoStyles.prizeCircleText}>
                      x
                    </Typography>
                  </Box>
                  <Typography sx={stepTwoStyles.prizeAmount}>
                    Voucher Emag 500 lei
                  </Typography>
                </Box>
                
                <Box
                  component="img"
                  src={premiu}
                  alt="Premiu Emag 500 LEI"
                  sx={stepTwoStyles.prizeImageInSection}
                />
              </Box>
            </Box>

            {/* Form Title */}
            <Typography variant="h6" sx={stepTwoStyles.formTitle}>
              Te rugam sa completezi cu datele tale
            </Typography>

            {/* Linia 1 - înainte de input-uri */}
            <Box sx={stepTwoStyles.lineContainer}>
              <Box
                component="img"
                src={linie1}
                alt="Linia 1"
                sx={stepTwoStyles.lineImage}
              />
            </Box>

            {/* Nume Field */}
            <TextField
              fullWidth
              placeholder="Nume"
              value={nume}
              onChange={(e) => onInputChange('nume', e.target.value)}
              error={Boolean(errors.nume)}
              helperText={errors.nume}
              sx={stepTwoStyles.textField}
            />

            {/* Linia 2 - după nume */}
            <Box sx={stepTwoStyles.lineContainer}>
              <Box
                component="img"
                src={linie2}
                alt="Linia 2"
                sx={stepTwoStyles.lineImage}
              />
            </Box>

            {/* Prenume Field */}
            <TextField
              fullWidth
              placeholder="Prenume"
              value={prenume}
              onChange={(e) => onInputChange('prenume', e.target.value)}
              error={Boolean(errors.prenume)}
              helperText={errors.prenume}
              sx={stepTwoStyles.textField}
            />

            {/* Linia 2 - după prenume */}
            <Box sx={stepTwoStyles.lineContainer}>
              <Box
                component="img"
                src={linie2}
                alt="Linia 2"
                sx={stepTwoStyles.lineImage}
              />
            </Box>

            {/* Telefon Field */}
            <TextField
              fullWidth
              placeholder="Număr de telefon"
              value={telefon}
              onChange={(e) => onInputChange('telefon', e.target.value)}
              error={Boolean(errors.telefon)}
              helperText={errors.telefon}
              sx={stepTwoStyles.textField}
              inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
            />

            {/* Linia 2 - final */}
            <Box sx={stepTwoStyles.lineContainerWithMargin}>
              <Box
                component="img"
                src={linie2}
                alt="Linia 2"
                sx={stepTwoStyles.lineImage}
              />
            </Box>

            {/* Continue Button */}
            <Box sx={stepTwoStyles.buttonContainer}>
              <Button
                variant="contained"
                disabled={!nume.trim() || !prenume.trim() || !telefon.trim() || 
                        !/^07\d{8}$/.test(telefon) ||
                        Boolean(errors.nume) || Boolean(errors.prenume) || Boolean(errors.telefon)}
                onClick={handleNext}
                sx={stepTwoStyles.continueButton}
              >
                CONTINUĂ
              </Button>
            </Box>

            {/* Footer Info */}
            <Box sx={stepTwoStyles.footer}>
              <Typography variant="caption" sx={stepTwoStyles.footerText}>
                Campania se desfășoară doar în locațiile selectate de organizator
              </Typography>
              
              <Box sx={stepTwoStyles.footerImageContainer}>
                <Box
                  component="img"
                  src={despre_alcool}
                  alt="Despre alcool"
                  sx={stepTwoStyles.footerImage}
                />
              </Box>
            </Box>
          </Box>
        </Paper>
    </Box>
  );
}